
import { random } from './src/random'
export = random
